import {
  getProfilesFromSessionStorage,
  Profile,
} from 'applicaiton/sessionStorage/auth';
import { usersRefreshToken } from 'applicaiton/store/reducers/Users/ActionCreators';
import { useAppDispatch } from './redux';

/**
 * Custom hook that provides functionality to refresh a user's authentication token.
 *
 * @returns An object with a single method: `refreshTokenForUser`.
 */
export const useUserProfile = () => {
  const dispatch = useAppDispatch();

  /**
   * Dispatches an action to refresh a user's authentication token using their email and refresh token stored in session storage.
   */
  const refreshTokenForUser = async () => {
    const profile: Profile[] | null = getProfilesFromSessionStorage();
    if (profile) {
      await dispatch(
        usersRefreshToken({
          refreshToken: profile[0].refreshToken,
          email: profile[0].email,
        }),
      );
    }
  };
  return {
    refreshTokenForUser,
  };
};
